import KpiElement from "../kpiElement/KpiElement";
import StatusBar from "../statusBar/StatusBar";
import "./StyleKpiContainer.css"

function KpiContainer(kpi_data) {
    if (kpi_data.kpi !== undefined) {
        return (
            <>
                <StatusBar flag={kpi_data.is_actual}/>
                <main>
                   {kpi_data.kpi.map((kpi)=>{
                        return(
                            <KpiElement
                                key={kpi.name}
                                name={kpi.name}
                                details={kpi.details}
                            />
                        )
                    })}
                </main>
            </>
        );
    }
}

export default KpiContainer;

